// Import Services
import Services from '../core/services'

export default {

  getSiteData( siteIdList ) {
    return new Promise((resolve) => {
      return Services
        .post("api/siterentals/sitedata", {
          siteIdList         
        })
        .then( ({data}) => {
          if (data && data.success) {
            return resolve({
              sitedata: data.sitedata || [],
            });
          }

          return resolve({});
        })
        .catch(() => {
          return resolve({});
        });         
    });
  },

  processRentals( formData ) {
    return new Promise((resolve) => {
      return Services
        .post(`api/siterentals/processrentals`, formData )
        .then( ({data}) => {
          if (data && data.success) {
            return resolve({
              success: true
            });  
          }

          return resolve({
            success: false,
            error: data.error,
          });
        })
        .catch(() => {
          return resolve({
            success: false
          });
        });
    });
  }

}